import React from 'react';
import { Icon, StatusChip } from '../../components/sp-primitives';
import { Modal } from '../../components/sp-overlays';
import {
  fmtLastPaymentAmount,
  fmtLastPaymentDate,
  fmtSiengeDetailSync,
  siengeBankDataIsEmpty,
} from './creditor-helpers';

export function CreditorListModals({
  syncTotalModal,
  onCloseSyncTotal,
  onFollowSyncLogs,
  bankModal,
  onCloseBank,
  paymentsModal,
  onClosePayments,
  addressModal,
  onCloseAddress,
  contactModal,
  onCloseContact,
}) {
  return (
    <>
      <Modal
        open={syncTotalModal.open}
        onClose={onCloseSyncTotal}
        width={420}
      >
        <div className="sp-modal__head">
          <div>
            <div className="sp-modal__head-title">Aguarde</div>
          </div>
        </div>
        <div className="sp-modal__body sp-modal__body--stack-lg sp-creditors-sync-total-modal">
          {(syncTotalModal.phase === 'running' || syncTotalModal.phase === 'queued') && (
            <>
              <p className="sp-sidebar-card__muted sp-creditors-sync-counter-hint">A sincronização total de credores foi acionada!</p>
              <div className="sp-modal-actions">
                <button type="button" className="sp-btn sp-btn-outline" onClick={onFollowSyncLogs}>
                  Acompanhar Logs
                </button>
                <button type="button" className="sp-btn sp-btn-accent" onClick={onCloseSyncTotal}>
                  Fechar e Aguardar
                </button>
              </div>
            </>
          )}
          {syncTotalModal.phase === 'done' && (
            <>
              <p className="sp-creditors-sync-done-msg">Base de credores atualizada.</p>
              <button type="button" className="sp-btn sp-btn-primary" onClick={onCloseSyncTotal}>
                Fechar modal
              </button>
            </>
          )}
        </div>
      </Modal>

      <Modal open={bankModal.open} onClose={onCloseBank} width={720}>
        <div className="sp-modal__head">
          <div>
            <div className="sp-modal__head-title">Dados bancários</div>
            <div className="sp-modal__head-desc">{bankModal.creditorName || 'Credor'}</div>
          </div>
          <button type="button" onClick={onCloseBank} className="sp-btn sp-btn-ghost sp-modal__close">
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="sp-modal__body sp-modal__body--stack-lg">
          {bankModal.loading && <div className="sp-sidebar-card__muted">A consultar a API Sienge…</div>}
          {bankModal.error && <div className="sp-creditors-banner sp-creditors-banner--err">{bankModal.error}</div>}
          {!bankModal.loading && !bankModal.error && bankModal.data && Array.isArray(bankModal.data.results) && bankModal.data.results.length > 0 && (
            <div className="sp-bank-table-wrap">
              <table className="sp-table sp-table--compact">
                <thead>
                  <tr>
                    <th>Forma</th>
                    <th>Banco</th>
                    <th>Nome do banco</th>
                    <th>Agência</th>
                    <th>Conta</th>
                    <th>DV</th>
                    <th>Tipo</th>
                    <th>Padrão</th>
                    <th>Titular</th>
                    <th>CPF</th>
                    <th>CNPJ</th>
                  </tr>
                </thead>
                <tbody>
                  {bankModal.data.results.map((b) => (
                    <tr key={b.id ?? `${b.bank}-${b.agency}-${b.accountNumber}`}>
                      <td>{b.paymentForm || '—'}</td>
                      <td className="sp-mono">{b.bank ?? '—'}</td>
                      <td>{b.nameOfBank || '—'}</td>
                      <td className="sp-mono">{b.agency ?? '—'}</td>
                      <td className="sp-mono">{b.accountNumber ?? '—'}</td>
                      <td className="sp-mono">{b.checkDigit ?? '—'}</td>
                      <td className="sp-mono">{b.accountType ?? '—'}</td>
                      <td>{b.defaultFlag === 'S' ? 'Sim' : b.defaultFlag === 'N' ? 'Não' : (b.defaultFlag ?? '—')}</td>
                      <td>{b.nameOfRecipient || '—'}</td>
                      <td className="sp-mono">{b.cpf || '—'}</td>
                      <td className="sp-mono">{b.cnpj || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {!bankModal.loading && !bankModal.error && bankModal.data && siengeBankDataIsEmpty(bankModal.data) && (
            <div className="sp-sidebar-card__muted" role="status">
              O Sienge não possui cadastro de dados bancários deste credor.
            </div>
          )}
          {!bankModal.loading && !bankModal.error && bankModal.data && !siengeBankDataIsEmpty(bankModal.data) && (!Array.isArray(bankModal.data.results) || bankModal.data.results.length === 0) && (
            <pre className="sp-bank-json-fallback">{JSON.stringify(bankModal.data, null, 2)}</pre>
          )}
        </div>
        <div className="sp-modal-actions">
          <button type="button" className="sp-btn sp-btn-outline" onClick={onCloseBank}>
            Fechar
          </button>
        </div>
      </Modal>

      <Modal open={addressModal.open} onClose={onCloseAddress} width={560}>
        <div className="sp-modal__head sp-modal__head--start">
          <div>
            <div className="sp-modal__head-title">Endereço</div>
            <div className="sp-modal__head-desc">{addressModal.creditorName || 'Credor'}</div>
            <div className="sp-modal__sync-line sp-mono">Última sincronização: {fmtSiengeDetailSync(addressModal.synced_at)}</div>
          </div>
          <button type="button" onClick={onCloseAddress} className="sp-btn sp-btn-ghost sp-modal__close">
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="sp-modal__body sp-modal__body--stack-lg">
          {addressModal.loading && <div className="sp-sidebar-card__muted">A carregar…</div>}
          {addressModal.error && <div className="sp-creditors-banner sp-creditors-banner--err">{addressModal.error}</div>}
          {!addressModal.loading && !addressModal.error && addressModal.address && (
            <dl className="sp-creditor-dl">
              <dt>Cidade</dt>
              <dd>{addressModal.address.cityName || '—'}</dd>
              <dt>Logradouro</dt>
              <dd>{addressModal.address.streetName || '—'}</dd>
              <dt>Número</dt>
              <dd>{addressModal.address.number || '—'}</dd>
              <dt>Complemento</dt>
              <dd>{addressModal.address.complement || '—'}</dd>
              <dt>UF</dt>
              <dd>{addressModal.address.state || '—'}</dd>
              <dt>CEP</dt>
              <dd className="sp-mono">{addressModal.address.zipCode || '—'}</dd>
            </dl>
          )}
          {!addressModal.loading && !addressModal.error && !addressModal.address && (
            <div className="sp-sidebar-card__muted">Sem registo de endereço na resposta da API.</div>
          )}
        </div>
        <div className="sp-modal-actions">
          <button type="button" className="sp-btn sp-btn-outline" onClick={onCloseAddress}>
            Fechar
          </button>
        </div>
      </Modal>

      <Modal open={contactModal.open} onClose={onCloseContact} width={720}>
        <div className="sp-modal__head sp-modal__head--start">
          <div>
            <div className="sp-modal__head-title">Telefones e contactos</div>
            <div className="sp-modal__head-desc">{contactModal.creditorName || 'Credor'}</div>
            <div className="sp-modal__sync-line sp-mono">Última sincronização: {fmtSiengeDetailSync(contactModal.synced_at)}</div>
          </div>
          <button type="button" onClick={onCloseContact} className="sp-btn sp-btn-ghost sp-modal__close">
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="sp-modal__body sp-modal__body--stack-lg">
          {contactModal.loading && <div className="sp-sidebar-card__muted">A carregar…</div>}
          {contactModal.error && <div className="sp-creditors-banner sp-creditors-banner--err">{contactModal.error}</div>}
          {!contactModal.loading && !contactModal.error && (
            <>
              <div>
                <div className="sp-caps sp-label" style={{ marginBottom: 8 }}>
                  Telefones (API Sienge)
                </div>
                {contactModal.phones.length > 0 ? (
                  <pre className="sp-bank-json-fallback">{JSON.stringify(contactModal.phones, null, 2)}</pre>
                ) : (
                  <div className="sp-sidebar-card__muted">Nenhum telefone na última sincronização.</div>
                )}
              </div>
              <div>
                <div className="sp-caps sp-label" style={{ marginBottom: 8 }}>
                  Contactos (API Sienge)
                </div>
                {contactModal.contacts.length > 0 ? (
                  <pre className="sp-bank-json-fallback">{JSON.stringify(contactModal.contacts, null, 2)}</pre>
                ) : (
                  <div className="sp-sidebar-card__muted">Nenhum contacto na última sincronização.</div>
                )}
              </div>
            </>
          )}
        </div>
        <div className="sp-modal-actions">
          <button type="button" className="sp-btn sp-btn-outline" onClick={onCloseContact}>
            Fechar
          </button>
        </div>
      </Modal>

      <Modal open={paymentsModal.open} onClose={onClosePayments} width={920}>
        <div className="sp-modal__head">
          <div>
            <div className="sp-modal__head-title">Pagamentos submetidos</div>
            <div className="sp-modal__head-desc">{paymentsModal.creditorName || 'Credor'}</div>
          </div>
          <button type="button" onClick={onClosePayments} className="sp-btn sp-btn-ghost sp-modal__close">
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="sp-modal__body sp-modal__body--stack-lg">
          {paymentsModal.loading && <div className="sp-sidebar-card__muted">A carregar pagamentos gravados no Sienge Pay…</div>}
          {paymentsModal.error && <div className="sp-creditors-banner sp-creditors-banner--err">{paymentsModal.error}</div>}
          {!paymentsModal.loading && !paymentsModal.error && (
            <div className="sp-bank-table-wrap">
              <table className="sp-table sp-table--compact">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th className="sp-th-num">Valor</th>
                    <th>Moeda</th>
                    <th>Status</th>
                    <th>Referência</th>
                    <th>Descrição</th>
                  </tr>
                </thead>
                <tbody>
                  {(paymentsModal.payload?.data || []).map((p) => (
                    <tr key={p.id}>
                      <td className="sp-mono">{fmtLastPaymentDate(p.payment_date)}</td>
                      <td className="sp-num sp-td-num">{fmtLastPaymentAmount(p.amount)}</td>
                      <td className="sp-mono">{p.currency || 'BRL'}</td>
                      <td><StatusChip kind={p.status === 'success' || p.status === 'sent' ? 'green' : p.status === 'error' ? 'red' : 'neutral'}>{p.status || '—'}</StatusChip></td>
                      <td className="sp-mono">{p.reference || '—'}</td>
                      <td>{p.description || '—'}</td>
                    </tr>
                  ))}
                  {!paymentsModal.payload?.data?.length && (
                    <tr>
                      <td colSpan={6} className="sp-td-empty">
                        Nenhum pagamento submetido para este credor.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="sp-modal-actions">
          <button type="button" className="sp-btn sp-btn-outline" onClick={onClosePayments}>
            Fechar
          </button>
        </div>
      </Modal>
    </>
  );
}
